module.exports = __webpack_public_path__ + "img/20190805162218QQ截图20190804233707.01f16feb.png";